module.exports = __webpack_public_path__ + "static/media/icon_car.34c3ba98.svg";